import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { sxStyles } from "../sharedStyles";

export const DesktopSkeleton = () => {
  const { desktopButtonPrice, desktopButtonRow } = sxStyles;

  return (
    <>
      <Box sx={desktopButtonPrice}>
        <Typography variant="h5">
          <Skeleton width={76} height={32} sx={{ marginBottom: "auto" }} />
        </Typography>
      </Box>
      <Box sx={desktopButtonRow}>
        <Skeleton width={50} height={20} />
        <Skeleton width={30} height={20} sx={{ marginLeft: "auto" }} />
      </Box>
    </>
  );
};

export const MobileSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="titleExtraSmall">
        <Skeleton width={20} />
      </Typography>
      <Typography variant="titleMedium" weight="bold">
        <Skeleton width={28} />
      </Typography>
    </Box>
  );
};
